import circle from "../img/circle.svg";
import triangle from "../img/triangle.svg";
import square from "../img/square.svg";
import star from "../img/star.svg";
import hexagon from "../img/hexagon.svg";
import patternSquare from "../img/pattern_square.svg";
import patternPortrait from "../img/pattern_portrait.svg";
import patternLandscape from "../img/pattern_landscape.svg";

export default [
	{
		src: circle,
		width: 1000,
		height: 1000,
		type: "img"
	},
	{
		src: patternPortrait,
		width: 1000,
		height: 1600,
		type: "img"
	},
	{
		src: triangle,
		width: 1000,
		height: 1000,
		type: "img"
	},
	{
		src: patternLandscape,
		width: 1600,
		height: 1000,
		type: "img"
	},
	{
		src: square,
		width: 1000,
		height: 1000,
		type: "img"
	},
	{
		src: patternSquare,
		width: 1000,
		height: 1000,
		type: "img"
	},
	{
		src: star,
		width: 1000,
		height: 1000,
		type: "img"
	},
	{
		src: patternPortrait,
		width: 1000,
		height: 1600,
		type: "img"
	},
	{
		src: hexagon,
		width: 1000,
		height: 1000,
		type: "img"
	},
	{
		src: patternLandscape,
		width: 1600,
		height: 1000,
		type: "img"
	},
	{
		src: circle,
		width: 1000,
		height: 1000,
		type: "img"
	},
	{
		src: patternPortrait,
		width: 1000,
		height: 1600,
		type: "img"
	},
	{
		src: triangle,
		width: 1000,
		height: 1000,
		type: "img"
	},
	{
		src: patternLandscape,
		width: 1600,
		height: 1000,
		type: "img"
	},
	{
		src: square,
		width: 1000,
		height: 1000,
		type: "img"
	},
	{
		src: patternSquare,
		width: 1000,
		height: 1000,
		type: "img"
	},
	{
		src: star,
		width: 1000,
		height: 1000,
		type: "img"
	},
	{
		src: patternPortrait,
		width: 1000,
		height: 1600,
		type: "img"
	},
	{
		src: hexagon,
		width: 1000,
		height: 1000,
		type: "img"
	},
	{
		src: patternLandscape,
		width: 1600,
		height: 1000,
		type: "img"
	}
];


// WEBPACK FOOTER //
// ./demo/src/data/testImages.js